import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_idprint } from "../shared/data.service";

import { wsPrintQueueInfo } from "../shared/wsPrintQueueInfo";
import { wsPrintQueueSetFeeParm } from "../shared/wsPrintQueueSetFeeParm";
import { wsSetFeeInfo } from "../shared/wsPrintQueueSetFeeParm";

import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./setfee.component.html",
	styleUrls: ["./setfee.component.css"],
})
export class SetFeeComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_idprint, public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public lstPrintQueueChecked: wsPrintQueueInfo[] = [];
	public DefaultFee: number = 0.0;
	public FeeAmount: number = 0.0;

	public ItemsChangedMessage: string = "";
	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.lstPrintQueueChecked = this.dialogConfig.data.lstPrintQueueChecked;
		this.DefaultFee = this.dialogConfig.data.DefaultFee;
		this.FeeAmount = this.DefaultFee;

		this.ItemsChangedMessage = "A total of " + this.lstPrintQueueChecked.length + " item(s) will have their fee set.";

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetFee
	//
	//-----------------------------------------------------------------------------------------------------
	onSetFee() {
		//
		//	Validate Number
		//
		this.ErrorMessage = "";

		if (this.FeeAmount == null) {
			this.FeeAmount = 0.0;
		}

		if (this.FeeAmount < 0.0) {
			this.ErrorMessage = "Please enter a positive dollar value.";
			return;
		}

		if (this.FeeAmount > 100.0) {
			this.ErrorMessage = "Fee amount cannot be greater then $100.00.";
			return;
		}

		//
		//	Validations Passed (Set Fee)
		//
		let parms: wsPrintQueueSetFeeParm = {
			ReprintFee: this.FeeAmount,
			SetFeeItems: [],
		};

		this.lstPrintQueueChecked.forEach((item) => {
			let r: wsSetFeeInfo = {
				IDPrintQueueID: item.IDPrintQueueID,
			};

			parms.SetFeeItems.push(r);
		});

		this.isBusy = true;
		this.dataService.IDPrintQueueSetFee(parms).subscribe((data) => this.IDPrintQueueSetFee_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueSetFee_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueSetFee_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
